import { Link } from 'react-router-dom';
import { AlertTriangle, Lock } from 'lucide-react';
import { useSubscription } from '@/features/admin/queries';
import { formatDate } from '@/lib/format';

/**
 * A strip above the workspace when the licence needs attention.
 *
 * Shown to everyone, not only the owner: the manager who suddenly cannot save
 * a client needs to know why before they file a bug, and the person who can
 * renew usually hears about it from them.
 */
export function LicenseBanner() {
  const { data: state } = useSubscription();
  if (!state?.needs_attention) return null;

  const readOnly = state.is_read_only;
  const message = readOnly
    ? 'Термін ліцензії минув — робочий простір працює лише на читання. Дані на місці, їх можна переглядати та вивантажувати.'
    : state.status === 'grace'
      ? `Оплачений період завершився. Система працює у звичайному режимі${
          state.grace_ends_on ? ` до ${formatDate(state.grace_ends_on)}` : ''
        }, далі — лише читання.`
      : `Ліцензія діє ще ${state.days_left} дн. (до ${formatDate(state.expires_on)}).`;

  return (
    <div
      role="status"
      className={`flex flex-wrap items-center gap-2 border-b px-4 py-2 text-sm ${
        readOnly
          ? 'border-danger/40 bg-danger/10 text-danger'
          : 'border-warning/40 bg-warning/10 text-warning'
      }`}
    >
      {readOnly ? (
        <Lock className="h-4 w-4 shrink-0" />
      ) : (
        <AlertTriangle className="h-4 w-4 shrink-0" />
      )}
      <span className="mr-auto">{message}</span>
      <Link to="/settings" className="font-medium underline underline-offset-2">
        Продовжити ліцензію
      </Link>
    </div>
  );
}
